module.exports = __webpack_public_path__ + "static/media/logoac.5004529b.png";